module.exports = __webpack_public_path__ + "static/media/chrysler-300c-2012-side.e60aa3f2.jpg";